module.exports = __webpack_public_path__ + "img/artforukraine.86a8c366.svg";